<template>
  <v-text-field
    :model-value="modelValue"
    @update:modelValue="updateValue"
    :label="label"
    :placeholder="placeholder"
    :density="density"
    :variant="variant"
    :readonly="readonly"
    :disabled="disabled"
    :color="color"
    :error="error"
    :error-messages="errorMessages"
    @input="$emit('input')"
  >
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps" />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "RbTextField",

  props: {
    modelValue: [String, Number],
    label: String,
    placeholder: String,
    density: {
      type: String,
      default: "compact",
    },
    variant: {
      type: String,
      default: "outlined",
    },
    color: {
      type: String,
      default: "primary",
    },
    readonly: Boolean,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["update:modelValue", "input"],

  methods: {
    updateValue(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>

<style scoped>
::v-deep(.v-field-label) {
  font-size: 12px !important;
}
::v-deep(.v-field__input) {
  font-size: 13px !important;
}
::v-deep(.v-field__input input::placeholder) {
  font-size: 12px !important;
}
::v-deep(.v-input__details) {
  padding: 0px !important;
  margin: 0px !important;
}
</style>
